export default __webpack_public_path__ + "static/pilot-Dan-ee018822a4e43afec8750524015c2326.png";